import { api } from 'app/api';
import { ApiResponse, UserDto } from 'dtos';

export const getSession = () =>
  api.get<ApiResponse<UserDto>>('account/session').then(res => res.data);
